<div 
    class="transition-all duration-500 ease-in-out overflow-hidden bg-white"
    [class.max-h-0]="!active"
    [class.max-h-screen]="active"
>
    <ng-content></ng-content>
</div>